module.exports = __webpack_public_path__ + "static/4-d5f37410812961a4bcebf89ff60696c2.svg";